const RELOAD_KEY = "stale-chunk-reload-at";
const RELOAD_GUARD_MS = 60_000;

// True from the moment we call location.reload() until the page actually unloads.
let reloadInFlight = false;

export const isStaleChunkReloadInFlight = () => reloadInFlight;

/** True if a stale-chunk reload is still allowed (none happened within the guard window). */
export function canReloadForStaleChunk(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
    return Date.now() - last >= RELOAD_GUARD_MS;
  } catch {
    return true;
  }
}

/**
 * Reload so the browser picks up the latest build. Returns false (and does nothing)
 * if we already reloaded within the guard window, to avoid a reload loop.
 */
export function reloadOnceForStaleChunk(): boolean {
  if (reloadInFlight) return true;
  if (!canReloadForStaleChunk()) return false;
  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage unavailable: reload anyway, the browser won't loop on its own
  }
  reloadInFlight = true;
  window.location.reload();
  return true;
}
